import { useState } from "react"
import styles from "./survey.module.scss"

interface Props {
  selectSurveryOption: (option: string) => void
  moveNextView: (view: string) => void
  onOtherTextChange: (text: string) => void
  surveyOption: string
  tierName: string
  trackCancelAction: (action: string, extraTags?: { [key: string]: string }) => void
}

const Survey = ({
  selectSurveryOption,
  moveNextView,
  onOtherTextChange,
  surveyOption,
  tierName,
  trackCancelAction,
}: Props) => {
  const [otherText, setOtherText] = useState("")

  const options = {
    plans_too_pricy: "Cost",
    not_using: "Not using",
    another_solution: "Found alternate solution",
    customer_support: "Technical issues",
    wrong_plan: "Wrong plan",
    other: "Other",
  }

  const handleOtherTextChange = (value: string) => {
    setOtherText(value)
    onOtherTextChange(value)
  }

  const nextViewFor = (option: string) => {
    switch (option) {
      case "customer_support":
        return "customer_support"
      case "wrong_plan":
        return "switch_your_plan"
      case "plans_too_pricy":
        // Pro+ is the only tier with a cheaper plan beneath it; Pro and legacy Pro would
        // otherwise be shown Pro+, an upgrade, in answer to a price complaint.
        return tierName === "Pro+" ? "switch_your_plan" : "exclusive_offer"
      case "not_using":
      case "another_solution":
      case "other":
        return "exclusive_offer"
    }
  }

  const onContinueClick = () => {
    const nextView = nextViewFor(surveyOption)
    if (!nextView) return

    trackCancelAction("cancel_survey_continue", { next_view: nextView })
    moveNextView(nextView)
  }

  return (
    <div className={styles.survey_container}>
      <h1 className="mb2--phone mb2--small-phone">Before you go</h1>

      <p className={styles.description}>Please select the reason you are canceling your subscription.</p>

      <div className={styles["options-container"]}>
        {Object.entries(options).map(([option, label]) => (
          <div key={option}>
            <div className={styles["radio-option"]} data-option={option} onClick={() => selectSurveryOption(option)}>
              <div className={`${styles["radio-circle"]} ${surveyOption === option ? styles.selected : ""}`} />
              <span className={styles["radio-label"]}>{label}</span>
            </div>
            {option === "other" && surveyOption === "other" && (
              <input
                name="other_reason"
                type="text"
                className={styles["other-input"]}
                placeholder="Tell us more"
                value={otherText}
                onChange={e => handleOtherTextChange(e.target?.value)}
              />
            )}
          </div>
        ))}
      </div>

      <div className="cancellation-actions cancellation-actions--survey">
        <button type="button" className="button-primary" onClick={onContinueClick} disabled={!surveyOption}>
          Continue
        </button>
      </div>
    </div>
  )
}

export default Survey
